<script setup lang="ts">
import { onMounted, ref } from 'vue';
import type { Csv } from '@/apis/generated/dialbunny';
import { closeModal, updateShow } from '@/app/components/modal/modals';
import { DtModal } from '@dialpad/dialtone/vue3/lib/modal';
import CsvImportUploadStep from '../CsvImportUploadStep/CsvImportUploadStep.vue';
import CsvImportMapStep from '../CsvImportMapStep/CsvImportMapStep.vue';
import { DATA_QA as MODAL_WRAPPER_DATA_QA } from '@/app/components/modal/modal-wrapper.constants';
import CsvImportDetailsStep from '../CsvImportDetailsStep/CsvImportDetailsStep.vue';
import logger from '@/logger';

const log = logger.getChild('CsvImport');

const examples = ref<string[]>([]);
const csv = ref<Csv | null>(null);

const step = ref(0);
const show = ref(false);
log.debug('Mounting');
onMounted(() => {
  show.value = true;
  log.debug('Mounted');
});
</script>
<template>
  <DtModal
    :data-qa="MODAL_WRAPPER_DATA_QA.DIALOG"
    :title="$ta('CSV_IMPORT_MODAL_TITLE')[`STEP_${step}`]"
    :close-button-props="{
      ariaLabel: $t('MODAL_CLOSE_ARIA_LABEL'),
      'aria-label': $t('MODAL_CLOSE_ARIA_LABEL'),
      'data-qa': MODAL_WRAPPER_DATA_QA.CLOSE,
    }"
    dialog-class="d-wmx912"
    content-class="d-wmx912 d-p4 d-mn4"
    :show="show"
    @update:show="updateShow"
  >
    <CsvImportUploadStep
      v-show="step === 0"
      v-model="csv"
      @update:examples="($event) => (examples = $event)"
      @continue="step = 1"
    />
    <CsvImportMapStep
      v-show="step === 1"
      v-model="csv"
      :examples="examples"
      @back="step = 0"
      @continue="step = 2"
    />
    <CsvImportDetailsStep
      v-if="csv"
      v-show="step === 2"
      :csv="csv"
      @back="step = 1"
      @continue="closeModal()"
    ></CsvImportDetailsStep>
  </DtModal>
</template>
